<script>
import {useEvaluationGravityStore} from "@/stores/Evaluation/EvaluationGravity";
import {onMounted, ref, watch} from "vue";
import useSharedData from "@/use/SharedData";
import axios from "axios";

export default {
    props: {
        value: [Number, Array],
        multiple: Boolean,
        label: String,
        type: String,
        readonly: Boolean,
        rules: Array,
    },
    setup(props) {
        const gravityStore = useEvaluationGravityStore();
        const {loading, inputColor, backgroundColor} = useSharedData();
        const gravity = ref(null);

        function findAll() {
            axios.get('/evaluationGravities', {params: {type: props.type}}).then(response => {
                gravityStore.setEvaluationGravities(response.data);
            }).finally(() => {
                loading.value = true;
            })
        }

        watch(() => props.value, () => {
            gravity.value = props.value;
        }, {immediate: true});

        onMounted(() => findAll());

        return {
            gravityStore,
            gravity,
            loading,
            inputColor,
            backgroundColor
        }
    }
};
</script>

<template>
    <div>
        <v-autocomplete
            v-model="gravity"
            :label="label"
            :items="gravityStore.evaluationGravities"
            item-value="id"
            item-text="name"
            outlined
            dense
            :readonly="readonly"
            :multiple="multiple"
            :chips="multiple"
            :deletable-chips="multiple"
            :clearable="!readonly"
            :color="inputColor"
            :background-color="backgroundColor"
            hide-details="auto"
            @input="$emit('input', gravity)"
            :rules="rules"
        ></v-autocomplete>

        <input type="hidden"/>
    </div>
</template>